<div class="custom-emails-container" *ngIf="!isLoadingEmails">
	<div class="search" *ngIf="!divView">
		<cpi-input-with-autocomplete
			[minInputLength]="0"
			[placeholder]="labels.lbl_geral_pesquisar"
			[availableOptions]="listEmailTypeListIAC"
			(onValueChange)="getValueTypeEmail($event)"
			[cleanValues]="divHide">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="emailTypeList"
			[height]="'60dvh'"
			[itemPadding]="'1%'"
			[insideSort]="true"
			[labels]="labels"
			(getSelectedItem)="getValueTypeEmail($event[0]['emailType'])">
		</cpi-msp-table>
	</div>

	<ng-container *ngIf="divView">
		<div class="header-wrap">
			<div class="tab selected">{{ labels.lbl_geral_configuracoes_de_email }}</div>
		</div>
		<div class="body-wrap">
			<ng-container *ngIf="divView">
				<div class="input-container">
					<span class="label">{{ labels.lbl_geral_emails_customizados_cadastrados }}:</span>
					<cpi-input-with-autocomplete
						[minInputLength]="0"
						[placeholder]="labels.lbl_geral_selecione"
						[availableOptions]="listEmailsLanguageIAC"
						(onValueChange)="getCustomId($event)"
						[cleanValues]="divHide">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_utilizar_email_padrao }}</span>
					<cpi-checkbox
						[forceText]="false"
						[value]="customEmailInterface.defaultEmail"
						(oValue)="customEmailInterface.defaultEmail = $event"
						[innerText]="customEmailInterface.defaultEmail == true ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="button-container" *ngIf="customEmailInterface.defaultEmail == true">
					<div
						class="button"
						[ngClass]="{ disabled: isUpdating || isChangingState }"
						(click)="updateEmailStatus((customEmailInterface.active = 0))">
						{{ labels.lbl_geral_desativar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isChangingState"></cpi-dot-bounce-loading-effect>
					</div>
					<div
						class="button"
						[ngClass]="{ disabled: isUpdating || isChangingState }"
						(click)="updateEmailStatus((customEmailInterface.active = 1))">
						{{ labels.lbl_geral_ativar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isChangingState"></cpi-dot-bounce-loading-effect>
					</div>
				</div>

				<div class="dotted-input-container" *ngIf="customEmailInterface.defaultEmail == false">
					<span>{{ labels.lbl_geral_escolha_idioma }}: *</span>
					<select (change)="customEmailInterface.language = $event.target.value">
						<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="'portuguese'">{{ labels.lbl_geral_portugues }}</option>
						<option [value]="'english'">{{ labels.lbl_geral_ingles }}</option>
						<option [value]="'spanish'">{{ labels.lbl_geral_espanhol }}</option>
						<option [value]="'slovak'">{{ labels.lbl_geral_eslovaco }}</option>
						<option [value]="'chinese'">{{ labels.lbl_geral_chines }}</option>
						<option [value]="'italian'">{{ labels.lbl_geral_italiano }}</option>
					</select>
				</div>

				<ng-container *ngIf="customEmailInterface.defaultEmail == false">
					<div class="input-container" *ngIf="customEmailInterface.formatEmail === 'HTML'">
						<span class="label">{{ labels.lbl_cmdb_email }}:</span>
						<angular-editor [config]="editorConfig" [(ngModel)]="customEmailInterface.textContent"> </angular-editor>
					</div>

					<div class="input-container" *ngIf="customEmailInterface.formatEmail === 'txt'">
						<span class="label">{{ labels.lbl_cmdb_email }}: *</span>
						<textarea
							class="input-textarea"
							[value]="customEmailInterface.textContent"
							(input)="customEmailInterface.textContent = $event">
						</textarea>
					</div>
				</ng-container>

				<div *ngIf="customEmailInterface.defaultEmail == false && fieldList.length > 0">
					<span>{{ labels.lbl_geral_parametros_no_email }}</span>

					<div class="parameters-container">
						<span>{{ labels.lbl_geral_palavra }}</span>
						<span>{{ labels.lbl_geral_parametro }}</span>
						<span></span>
						<ng-container *ngFor="let item of fieldList; let index = index">
							<span>{{ item.tLabel }}</span>
							<span>{{ item.parameter }}</span>
							<span class="copy" (click)="copyParam(item, index)"><fa-icon [icon]="icons.faCopy"></fa-icon></span>
						</ng-container>
					</div>
				</div>

				<div class="button-container" *ngIf="customEmailInterface.defaultEmail == false">
					<div class="button" (click)="divView = false">{{ labels.lbl_geral_voltar }}</div>
					<div class="button" (click)="clearCustomEmailFields()">{{ labels.lbl_geral_limpar_campos }}</div>
					<div class="button" [ngClass]="{ disabled: isUpdating || isChangingState }" (click)="deleteCustomId()">
						{{ labels.lbl_geral_excluir }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isChangingState"></cpi-dot-bounce-loading-effect>
					</div>
					<div class="button" [ngClass]="{ disabled: isUpdating || isChangingState }" (click)="saveTemplate()">
						{{ labels.lbl_geral_salvar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingEmails"></cpi-dot-bounce-loading-effect>
